// extracted by mini-css-extract-plugin
export var quillEditor = "_ns-1";
export var variable = "_ns-0";